import React, { createContext, useContext, useState, useCallback } from 'react';

const VideoTimeContext = createContext();

export function useVideoTime() {
  return useContext(VideoTimeContext);
}

export function VideoTimeProvider({ children }) {
  const [videoTime, setVideoTime] = useState(0);

  const updateVideoTime = useCallback((newTime) => {
    setVideoTime(newTime);
  }, []);

  return (
    <VideoTimeContext.Provider value={{ videoTime, updateVideoTime }}>
      {children}
    </VideoTimeContext.Provider>
  );
}
